function Studiothink() {

  this.consts = {
    namespace: 'studiothink',
    breakpoints: {
      no: 0, 
      xs: 480,
      sm: 600,
      md: 782,
      lg: 960,
      xl: 1080,
      xxl: 1280,
      xxxl: 1440
    },
    breakpoint: 'md',
    breakpointNav: 'lg',
    transition: {
      fast: 275,
      medium: 400,
      slow: 650
    }
  };

  this.observeElements = '#site-header > *, h1, h2, h3, h4, h5, p, .wp-block-image, .frm_forms, #site-footer > .wp-block-group, .wp-block-button, .image-btn-link, .is-style-masked, .footer-menu, .funding-card';
    this.skipElements = '.skip-observing, .no-animation, .is-style-white-tr-down, .mobile-login-buttons, .slider-2, .slider-1, .header-group'; // Add your skip selectors here

  this.viewPort = {
    width: document.documentElement.clientWidth,
    height: document.documentElement.clientHeight,
    scrollbarYWidth: window.innerWidth - document.documentElement.clientWidth,
    scrollbarXHeight: window.innerHeight - document.documentElement.clientHeight
  };
  this.uniqueIdLast = 0;
  
  this.header = {
    obj: document.querySelector( 'header.page-header' ),
    height: {
      no: 97,
      md: 132
    }
  }

  this.windowPageYOffsetLast = 0;

  var st = this;
  this.isSmallScreen = function( breakpoint ) {
    breakpoint = breakpoint || st.consts.breakpoint;
    return ( st.consts.breakpoints[ breakpoint ] > st.viewPort.width );
  };
  this.isSmallScreenNav = function() {
    return ( st.consts.breakpoints[ st.consts.breakpointNav ] > st.viewPort.width + st.viewPort.scrollbarYWidth );
  };
  
  this.resize = function() {

    st.viewPort = {
      width: document.documentElement.clientWidth,
      height: window.visualViewport.height,
      scrollbarYWidth: window.innerWidth - document.documentElement.clientWidth,
      scrollbarXHeight: window.innerHeight - document.documentElement.clientHeight
    }
    
    document.documentElement.style.setProperty('--vh',st.viewPort.height*.01+'px');
    document.documentElement.style.setProperty('--vw',st.viewPort.width*.01+'px');
    document.documentElement.style.setProperty('--sw',st.viewPort.scrollbarYWidth+'px');

    if ( !st.isSmallScreenNav() ) {

      if ( document.documentElement.classList.contains( 'toggle-main-nav' ) ) document.documentElement.classList.remove( 'toggle-main-nav' );

    }
    
  };

  this.uniqueId = function( prefix ) {
    
    var id = '' + ++st.uniqueIdLast;
    return prefix ? prefix + id : 'st-' + id;
  };
    
  function init() {
    
    if ( window.st ) return false;

    document.documentElement.classList.add('st-initialized');
    if ( 'ontouchstart' in document.documentElement ) document.documentElement.classList.add('st-touch');
    if ( st.header.height.md <= window.pageYOffset ) document.documentElement.classList.add('st-scrolling');
    
    st.resize();
    
    return true;
  }
  init();
  
  window.st = window.st || this;
  
}
new Studiothink();

( function( $ ) {

  $( function() {

    st.resize();
    st.windowPageYOffsetLast = window.pageYOffset;

    $(window).on( 'load', function() { // ON LOAD 




    } ).on( 'resize orientationchange', function() { // ON RESIZE



      st.resize();
      
    } ).on( 'scroll', function( e ) { // ON SCROLL 

     

      if ( 0 === window.pageYOffset ) document.documentElement.classList.remove( 'is-scrolling' );
      else{ 
        
        document.documentElement.classList.add( 'is-scrolling' );
         $('.wp-block-navigation-submenu__toggle').each(function() {
    //    if (!$(this).attr('aria-expanded')) {
            $(this).attr('aria-expanded', 'false');
      //  }
    });
      //   $(document).trigger('click');
      }

      if ( 0 === window.pageYOffset || st.windowPageYOffsetLast < window.pageYOffset ){ 
        document.documentElement.classList.remove( 'is-scrolling-up' );
        

      }else{ 
        document.documentElement.classList.add( 'is-scrolling-up' );
       

      }

      st.windowPageYOffsetLast = window.pageYOffset;

    } ).on( 'hashchange', function( e ) { // ON HASHCHANGE 
      
      if ( window.location.hash.match( /^#?!\// ) ) {
        
        e.preventDefault();
        st.hashParts = window.location.hash.replace( /\/$/, '').split('/');
        
        if ( 'string' === typeof st.hashParts[1] ) {
          
          if ( 'top' === st.hashParts[1] ) {
            
            $( 'html, body' ).stop( true ).animate( { scrollTop: 0 }, st.consts.transition.slow );
            history.replaceState( undefined, document.title, window.location.pathname );
            
          } else if ( 'start' === st.hashParts[1] ) {
            
            var $target = $( '#site-main > div:nth-child(2)' );
            $( 'html, body' ).stop( true ).animate( { scrollTop: $target.offset().top - st.header.height.md }, st.consts.transition.slow );
            history.replaceState( undefined, document.title, window.location.pathname );
            $target.focus();
            
          } else if ( 'undefined' === typeof st.hashParts[2] && $( '#' + st.hashParts[1] ).length ) {
            
            var $target = $( '#' + st.hashParts[1] );
            $('html, body').stop( true ).animate( { scrollTop: $target.offset().top - st.header.height.md }, st.consts.transition.slow, function() {
              
            } );
          
          } else if ( st.hashParts[1].length && 'string' === typeof st.hashParts[2] ) {
            
            if ( 0 < st.hashParts[2].length ) {
              
              switch( st.hashParts[1] ) {
                case 'modal':
                  var modal = document.getElementById( 'stmu-modal-content-' + st.hashParts[2] );
                  if ( modal && lity ) {
                    lity( modal );
                  }
                  history.replaceState( undefined, document.title, window.location.pathname );
                break;
              }

            }

          }

          if ( document.documentElement.classList.contains( 'toggle-main-nav' ) ) document.documentElement.classList.remove( 'toggle-main-nav' );
          if ( document.documentElement.classList.contains( 'toggle-mobile-nav' ) ) document.documentElement.classList.remove( 'toggle-mobile-nav' );
          
        }
        return false;
      } else if (window.location.hash.match( /^#?/ ) && window.location.hash.length > 1) {
        e.preventDefault();

        if ( $( window.location.hash ).length ) {
            
          var $target = $( window.location.hash );
          $('html, body').stop( true ).animate( { scrollTop: $target.offset().top - st.header.height.md }, st.consts.transition.slow, function() {
            
          } );
          if ( document.documentElement.classList.contains( 'toggle-main-nav' ) ) document.documentElement.classList.remove( 'toggle-main-nav' );
          if ( document.documentElement.classList.contains( 'toggle-mobile-nav' ) ) document.documentElement.classList.remove( 'toggle-mobile-nav' );
        }
        
      }
      
    } ).trigger( 'scroll' );
    if ( window.location.hash.length ) $( window ).trigger( 'hashchange' );

    $( '[data-toggle-id]' ).on( 'click', function( e ) {
      
      e.preventDefault();

      var id = this.dataset.toggleId;
      
      if ( document.documentElement.classList.contains( 'toggle-' + id ) ) {
        document.documentElement.classList.remove( 'toggle-' + id );
        document.getElementById( id ).setAttribute('aria-expanded', false);
      } else {
        document.documentElement.classList.add( 'toggle-' + id );
        document.getElementById( id ).setAttribute('aria-expanded', true);
      }
      
    } );



    //lity on video link//
    $('a[href]:not([data-lity])').each( function() {
      var is_video = false;
      if ( 'string' === typeof this.href ) {
        if ( -1 !== this.href.indexOf( 'youtu.be' ) ) is_video = true;
        // if ( -1 !== this.href.indexOf( '.youtube.' ) ) is_video = true;
        if ( -1 !== this.href.indexOf( '.mp4' ) ) is_video = true;
        if ( -1 !== this.className.indexOf( 'button-video' ) ) is_video = true;
        if ( -1 !== this.parentNode.className.indexOf( 'button-video' ) ) is_video = true;
      }
      if ( true === is_video && 'function' === typeof lity ) {
        if ( -1 === this.className.indexOf( 'button-video' ) ) this.className += ' button-video';
        this.setAttribute( 'data-lity-extra' , 'true' );
      }
    } );
    $( document ).on( 'click', '[data-lity-extra]', lity);

    $('.wp-block-video > video').each( function() {

      var video = this, block = this.parentNode;
      video.controls = false;

      block.classList.add( 'play-me' );
      block.addEventListener( 'click', function( e ) {

        if ( !this.classList.contains( 'play-me' ) ) return;

        e.preventDefault();
        e.stopPropagation();

        this.classList.remove( 'play-me' );
        video.controls = true;
        video.play();

      } );

    } );

    if ( 'IntersectionObserver' in window ) {
  
      var parallaxOffsetTravel = function( element ) {

        this.element = element;
        let target = this;

        return function( event ) {

          var rect = target.element.getBoundingClientRect(), height = target.element.clientHeight;
          var offsetTop = rect.top + window.pageYOffset;
            
          var start = offsetTop - document.documentElement.clientHeight, end = offsetTop + height, distance = parseInt( target.element.dataset.parallaxDistance ), direction = target.element.dataset.parallaxDirection;
  
          if ( isNaN( distance ) ) distance = 100;
          if ( 'Y' !== direction ) direction = 'X';

          var travelDistance = rect.height * 2 + document.documentElement.clientHeight;
          var travelPosition = window.pageYOffset + document.documentElement.clientHeight - offsetTop;

          if ( 0 > travelPosition ) travelPosition = 0;
          if ( travelDistance < travelPosition ) travelPosition = travelDistance;

          var transformOffset = distance * ( travelPosition / travelDistance ) - ( distance / 2 );

          target.element.style.transform = 'translate' + direction + '(' + transformOffset + 'px)';

        } 
  
      }

      var observeSection = new IntersectionObserver( function( entries ) {
        
        entries.forEach( function( entry ) {
        
          var content = entry.target;
          
          if ( entry.isIntersecting ) {
            
            content.classList.add( 'intersected' );
            content.classList.add( 'intersecting' );

            if ( content.dataset.parallax && content.parallaxOffsetTravel ) window.addEventListener( 'scroll', content.parallaxOffsetTravel );

            if ( content.classList.contains( 'last-line' ) ) {
              content.parentNode.classList.add( 'intersected' );
            }

            if ( content.classList.contains( 'first-line' ) && content.parentNode.classList.contains( 'intersected' ) ) {
              content.parentNode.classList.remove( 'intersected' );
            }

          } else {

            content.classList.remove( 'intersecting' );

            if ( content.dataset.parallax && content.parallaxOffsetTravel ) window.removeEventListener( 'scroll', content.parallaxOffsetTravel );

          }
          
        });
        
      } );
      
      // Standard fade-in and slide-up.
   // Standard fade-in and slide-up.
    var contentNodes = document.querySelectorAll(st.observeElements);

for (var i = 0; i < contentNodes.length; i++) {
  // Skip if element matches any skip selector or is contained within a skipped element
  if (contentNodes[i].matches(st.skipElements) || contentNodes[i].closest(st.skipElements)) {
    continue;
  }

  if (!contentNodes[i].closest('.observing')) {
    contentNodes[i].classList.add('observing');
    if (0 !== window.pageYOffset) contentNodes[i].classList.add('intersected');
    else observeSection.observe(contentNodes[i]);

    if (contentNodes[i].classList.contains('last-line')) {
      contentNodes[i].parentNode.classList.add('observing');
      if (0 !== window.pageYOffset) contentNodes[i].parentNode.classList.add('intersected');
    }
  }
}

      // Parallax effects.
      function initParallaxElements() {
        // Handle regular parallax-el elements (always active)
        var contentNodes = document.querySelectorAll('.parallax-el');
        for (var i = 0; i < contentNodes.length; i++) {
          // Only initialize if not already initialized
          if (!contentNodes[i].parallaxOffsetTravel) {
            contentNodes[i].dataset.parallax = true;
      
            if (contentNodes[i].classList.contains('image-1')) {
              contentNodes[i].dataset.parallaxDistance = -150;
              contentNodes[i].dataset.parallaxDirection = 'Y';
            } else if (contentNodes[i].classList.contains('image-2')) {
              contentNodes[i].dataset.parallaxDistance = 200;
              contentNodes[i].dataset.parallaxDirection = 'Y';
            } else if (contentNodes[i].parentNode.classList.contains('line-1')) {
              contentNodes[i].dataset.parallaxDistance = 25;
              contentNodes[i].dataset.parallaxDirection = 'X';
            } else if (contentNodes[i].parentNode.classList.contains('line-2')) {
              contentNodes[i].dataset.parallaxDistance = -25;
              contentNodes[i].dataset.parallaxDirection = 'X';
            } else if (contentNodes[i].parentNode.classList.contains('line-3')) {
              contentNodes[i].dataset.parallaxDistance = -50;
              contentNodes[i].dataset.parallaxDirection = 'Y';
            } else if (contentNodes[i].classList.contains('compass-graphic')) {
              contentNodes[i].dataset.parallaxDistance = 100;
              contentNodes[i].dataset.parallaxDirection = 'Y';
            } else {
              contentNodes[i].dataset.parallaxDistance = 200;
              contentNodes[i].dataset.parallaxDirection = 'Y';
            }
      
            contentNodes[i].parallaxOffsetTravel = new parallaxOffsetTravel(contentNodes[i]);
            observeSection.observe(contentNodes[i]);
          }
        }
      
        // Handle parallax-mobile elements only under 1024px
        var mobileContentNodes = document.querySelectorAll('.parallax-mobile');
        for (var i = 0; i < mobileContentNodes.length; i++) {
          // Check if viewport is less than 1024px
          if (window.innerWidth < 1024) {
            // Only initialize if not already initialized
            if (!mobileContentNodes[i].parallaxOffsetTravel) {
              mobileContentNodes[i].dataset.parallax = true;
      
              if (mobileContentNodes[i].classList.contains('image-1')) {
                mobileContentNodes[i].dataset.parallaxDistance = -150;
                mobileContentNodes[i].dataset.parallaxDirection = 'Y';
              } else if (mobileContentNodes[i].classList.contains('image-2')) {
                mobileContentNodes[i].dataset.parallaxDistance = 200;
                mobileContentNodes[i].dataset.parallaxDirection = 'Y';
              } else if (mobileContentNodes[i].parentNode.classList.contains('line-1')) {
                mobileContentNodes[i].dataset.parallaxDistance = 25;
                mobileContentNodes[i].dataset.parallaxDirection = 'X';
              } else if (mobileContentNodes[i].parentNode.classList.contains('line-2')) {
                mobileContentNodes[i].dataset.parallaxDistance = -25;
                mobileContentNodes[i].dataset.parallaxDirection = 'X';
              } else if (mobileContentNodes[i].parentNode.classList.contains('line-3')) {
                mobileContentNodes[i].dataset.parallaxDistance = -50;
                mobileContentNodes[i].dataset.parallaxDirection = 'Y';
              } else if (mobileContentNodes[i].classList.contains('compass-graphic')) {
                mobileContentNodes[i].dataset.parallaxDistance = 100;
                mobileContentNodes[i].dataset.parallaxDirection = 'Y';
              } else {
                mobileContentNodes[i].dataset.parallaxDistance = 200;
                mobileContentNodes[i].dataset.parallaxDirection = 'Y';
              }
      
              mobileContentNodes[i].parallaxOffsetTravel = new parallaxOffsetTravel(mobileContentNodes[i]);
              observeSection.observe(mobileContentNodes[i]);
            }
          } else {
            // COMPLETELY destroy parallax for mobile elements above 960px
            if (mobileContentNodes[i].parallaxOffsetTravel) {
              // Remove from IntersectionObserver
              observeSection.unobserve(mobileContentNodes[i]);
              
              // Reset all parallax-related attributes and styles
              mobileContentNodes[i].dataset.parallax = false;
              delete mobileContentNodes[i].dataset.parallaxDistance;
              delete mobileContentNodes[i].dataset.parallaxDirection;
              mobileContentNodes[i].style.transform = '';
              mobileContentNodes[i].style.transition = '';
              
              // Destroy the parallax instance
              // If your parallax library has a destroy method, call it here
              // For example: mobileContentNodes[i].parallaxOffsetTravel.destroy();
              mobileContentNodes[i].parallaxOffsetTravel = null;
            }
          }
        }
      }
      
      // Initialize on page load
      initParallaxElements();
      
      // Use matchMedia for better performance on resize
      const mediaQuery = window.matchMedia('(max-width: 1023px)');
      mediaQuery.addEventListener('change', function(e) {
        initParallaxElements();
      });
      
    }

    // Add classes and ID to page  sections
    let sectionCount = 1;
    $('#site-main').children('.wp-block-cover, .wp-block-columns, .wp-block-group').each(function() {
      $(this).addClass('section-'+sectionCount);
      if (!$(this).attr('id')) {
        $(this).attr('id', 'section-'+sectionCount);
      }
      sectionCount++;
    });
    // Rewrite scroll down arrow href on hero to next section id
    $('.studiothink-scroll-down').each(function() {
      let nextSiblingAnchor = '#' + $(this).next().attr('id');
      $(this).attr('href', nextSiblingAnchor);
    });

  //  Select 2
    $('.select2').find('select').select2({
      minimumResultsForSearch: Infinity,
      dropdownAutoWidth: true,
      theme: "flat"
    });

    // handle form field labels
    $('.frm_form_field input, .frm_form_field select, .frm_form_field textarea').on('change', function() {
      if ($(this).val().length > 0) {
        $(this).parent().addClass("has-val");
      } else {
        $(this).parent().removeClass("has-val");
      }
    });


    if($('.wp-block-table').length > 0) {

      $('.wp-block-table').each(function() {
        let $thisTable = $(this);
        let columnLabels = [];

        $thisTable.find('th').each(function() {
          columnLabels.push($(this).text());
        }).promise().done(function() {
          $thisTable.find('tbody tr').each(function() {
  
            $(this).find('td').each(function(i) {
              $(this).attr('data-label', columnLabels[i]);
            });
          });

        });

      });
    }

      
  } );

} )( jQuery );
( function( $ ) {

    $(document).ready( function() {



    // Add hover class to container when any item is hovered
    $('.footer-menu .wp-block-navigation__container')
        .on('mouseover', function() {
            $(this).addClass('has-hover');
        })
        .on('mouseout', function() {
            $(this).removeClass('has-hover');
        });

 // Function to duplicate login button for mobile menu
    function duplicateLoginButton() {
        // Find the login button container
        const $loginButtons = $('.wp-block-buttons:has(.login-btn)');
        
        if ($loginButtons.length) {
            // Clone the login buttons
            const $clonedLoginButtons = $loginButtons.clone();
            
            // Add a class to differentiate it
            $clonedLoginButtons.addClass('mobile-login-buttons');
            
            // Add class to the button inside as well for specific styling
            $clonedLoginButtons.find('.login-btn').addClass('mobile-login-btn').removeClass('login-btn'). removeClass('observing');
            
            // Append to the mobile navigation container
            $('.wp-block-navigation__responsive-container-content').append($clonedLoginButtons);
        }
    }

    // Initialize on page load
    duplicateLoginButton();

// Add menu toggle inner span
    $('.wp-block-navigation__responsive-container-open').each(function() {
        const $button = $(this);
        // Wrap the inner content with a span if it doesn't already have one
        if (!$button.children('span').length) {
            $button.wrapInner('<span class="menu-toggle-inner"></span>');
        }
    });

//form submit buttons

    $('.frm_button_submit').each(function() {
        const $button = $(this);
        // Wrap the inner content with a span if it doesn't already have one
         if (!$(this).find('.wp-block-button__text').length) {
            $(this).wrapInner('<span class="wp-block-button__text"></span>');
        }
    });

//blue logo in header

    var $originalLogo = $('.main-logo .custom-logo-link img.custom-logo');
    var $blueLogo = $originalLogo.clone();
    
    $blueLogo.attr({
        'src': $blueLogo.attr('src').replace('Logo.svg', 'Logo-blue.svg'),
        'class': 'custom-logo-blue'
    });
    
    $originalLogo.before($blueLogo);

 var $video = $('.wp-block-cover__video-background');
    
    // Remove the autoplay attribute first to prevent conflicts
    $video.prop('autoplay', false);
    
    // Function to attempt playback
    function attemptVideoPlayback() {
        if ($video.length === 0) return;
        
        // Check if video metadata is loaded
        if ($video[0].readyState >= 2) {
            var playPromise = $video[0].play();
            
            if (playPromise !== undefined) {
                playPromise.catch(function(error) {
                    console.log('Auto-play prevented:', error);
                    // Fallback: add a subtle overlay with play button? 
                    // Or just keep the static background visible
                });
            }
        } else {
            // Wait for metadata to load
            $video.on('loadedmetadata', function() {
                $video[0].play().catch(function(e) {
                    console.log('Still blocked:', e);
                });
            });
        }
    }
    
    // iOS/macOS specific: listen for 'suspend' event (Low Power Mode trigger)
    $video.on('suspend', function() {
        console.log('Video suspended (likely Low Power Mode)');
        setTimeout(function() {
            attemptVideoPlayback();
        }, 100); // Small delay to allow system to settle
    });
    
    // Try to play immediately
    attemptVideoPlayback();
    
    // Retry on visibility change (when user returns to tab)
    $(document).on('visibilitychange', function() {
        if (!document.hidden) {
            setTimeout(function() {
                attemptVideoPlayback();
            }, 500);
        }
    });
    
    // Retry on user interaction (tap/click anywhere - helpful for iOS)
    $(document).one('touchstart click', function() {
        attemptVideoPlayback();
    });
    
    // Ensure video plays when it becomes visible (for lazy loading scenarios)
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                attemptVideoPlayback();
                observer.disconnect(); // Only need once
            }
        });
    });
    
    if ($video.length) {
        observer.observe($video[0]);
    }
    
    // Force attempt after page fully loads (including all assets)
    $(window).on('load', function() {
        setTimeout(function() {
            attemptVideoPlayback();
        }, 300);
    });
// script for team sections:

 $('.team-section').hide();

    // Function to show the team section matching the active button
    function showActiveSection() {
        var $activeBtn = $('.wp-block-buttons.team-btns .wp-block-button.active');
        if ($activeBtn.length) {
            var href = $activeBtn.find('.wp-block-button__link').attr('href');
            if (href && href.startsWith('#')) {
                $(href).show();
            }
        }
    }

    // 2. Show the section matching the initially active button
    showActiveSection();

    // 3. Handle click on any team button
    $('.wp-block-buttons.team-btns .wp-block-button').on('click', function(e) {
        e.preventDefault();

        // Remove .active from all buttons
        $('.wp-block-buttons.team-btns .wp-block-button').removeClass('active');

        // Add .active to the clicked button
        $(this).addClass('active');

        // Hide all team sections
        $('.team-section').hide();

        // Get the href of the clicked button's link
        var href = $(this).find('.wp-block-button__link').attr('href');

        // Show the matching section
        if (href && href.startsWith('#')) {
            $(href).show();
        }
    });

    } );

} )( jQuery );